/* 登录页面样式 */

/* 登录方式切换按钮 */
.login-method-toggle {
  display: flex;
  margin-bottom: 1.5rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  padding: 4px;
  width: 100%;
}

.login-method-toggle button {
  flex: 1;
  background: none;
  border: none;
  padding: 10px 15px;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.login-method-toggle button.active {
  background: rgba(88, 101, 242, 0.7);
  color: white;
  box-shadow: 0 2px 10px rgba(88, 101, 242, 0.3);
}

.login-method-toggle button:hover:not(.active) {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}

/* 表单组样式优化 */
.form-group {
  margin-bottom: 1.2rem;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
}

.form-input {
  width: 100%;
  padding: 12px 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: rgba(88, 101, 242, 0.8);
  box-shadow: 0 0 0 2px rgba(88, 101, 242, 0.25);
}

.form-input:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* 输入框和按钮组合 */
.input-with-button {
  display: flex;
  gap: 10px;
}

.input-with-button .form-input {
  flex: 1;
}

.send-code-btn {
  background: rgba(88, 101, 242, 0.7);
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0 15px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.send-code-btn:hover:not(:disabled) {
  background: rgba(88, 101, 242, 0.9);
}

.send-code-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* 提交按钮 */
.key-submit {
  width: 100%;
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.9), rgba(101, 88, 245, 0.9));
  color: white;
  border: none;
  border-radius: 8px;
  padding: 14px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(88, 101, 242, 0.3);
}

.key-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, rgba(88, 101, 242, 1), rgba(101, 88, 245, 1));
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(88, 101, 242, 0.4);
}

.key-submit:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.key-submit .arrow-icon {
  font-style: normal;
  transition: transform 0.3s ease;
}

.key-submit:hover:not(:disabled) .arrow-icon {
  transform: translateX(3px);
}

/* 页脚样式 */
.gate-footer {
  margin-top: 1.5rem;
  text-align: center;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.7);
}

.toggle-auth-btn {
  background: none;
  border: none;
  color: rgba(88, 101, 242, 1);
  font-weight: 500;
  cursor: pointer;
  padding: 0 5px;
  transition: all 0.3s ease;
}

.toggle-auth-btn:hover {
  color: rgba(88, 101, 242, 0.8);
  text-decoration: underline;
}

/* 提示信息样式 */
.auth-success, 
.auth-error {
  margin-bottom: 1rem;
  padding: 10px;
  border-radius: 8px;
  text-align: center;
  font-size: 0.9rem;
}

.auth-success {
  background: rgba(46, 213, 115, 0.15);
  color: #2ed573;
  border: 1px solid rgba(46, 213, 115, 0.3);
}

.auth-error {
  background: rgba(255, 71, 87, 0.15);
  color: #ff4757;
  border: 1px solid rgba(255, 71, 87, 0.3);
}

.code-hint {
  margin-top: 6px;
  font-size: 0.8rem;
  color: rgba(88, 101, 242, 0.8);
}

/* 卡片样式增强 */
.gate-card {
  backdrop-filter: blur(10px);
}

.gate-card-inner {
  padding: 2rem;
  background: rgba(13, 17, 23, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4);
}

/* 特色标签容器 */
.feature-badges {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
  flex-wrap: wrap;
  animation: fadeInUp 0.8s ease-out 0.3s both;
}

.feature-badge {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.15), rgba(101, 88, 245, 0.15));
  border: 1px solid rgba(88, 101, 242, 0.3);
  border-radius: 20px;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  cursor: default;
}

.feature-badge i {
  font-size: 1.1rem;
  color: rgba(88, 101, 242, 1);
  animation: pulse 2s ease-in-out infinite;
}

.feature-badge:hover {
  transform: translateY(-2px);
  background: linear-gradient(135deg, rgba(88, 101, 242, 0.25), rgba(101, 88, 245, 0.25));
  border-color: rgba(88, 101, 242, 0.5);
  box-shadow: 0 4px 15px rgba(88, 101, 242, 0.3);
}

/* 标语文字增强 */
.gate-tagline {
  font-size: 1.1rem;
  background: linear-gradient(135deg, #a8b2ff, #c7d0ff, #a8b2ff);
  background-size: 200% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: gradientShift 3s ease infinite;
  font-weight: 500;
  text-align: center;
  margin-top: 1rem;
  letter-spacing: 0.5px;
}

/* 渐变移动动画 */
@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* 淡入上移动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 脉冲动画 */
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
}

/* Logo容器装饰增强 */
.gate-logo-container {
  position: relative;
  margin-bottom: 2rem;
  text-align: center;
}

.gate-logo-container::before,
.gate-logo-container::after {
  content: '';
  position: absolute;
  width: 100px;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(88, 101, 242, 0.5), transparent);
  top: 50%;
  animation: lineGlow 2s ease-in-out infinite;
}

.gate-logo-container::before {
  left: -120px;
}

.gate-logo-container::after {
  right: -120px;
}

@keyframes lineGlow {
  0%, 100% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
}

/* 卡片入场动画 */
.gate-card {
  animation: cardSlideIn 0.6s ease-out;
}

@keyframes cardSlideIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 输入框聚焦时的光效 */
.form-input:focus {
  outline: none;
  border-color: rgba(88, 101, 242, 0.8);
  box-shadow: 0 0 0 2px rgba(88, 101, 242, 0.25), 0 0 15px rgba(88, 101, 242, 0.15);
}

/* 按钮波纹效果 */
.key-submit {
  position: relative;
  overflow: hidden;
}

.key-submit::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.key-submit:active::before {
  width: 300px;
  height: 300px;
}

/* 悬浮装饰元素 */
.gate-container::before {
  content: '';
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(88, 101, 242, 0.1), transparent);
  border-radius: 50%;
  top: -150px;
  right: -100px;
  pointer-events: none;
  animation: float 6s ease-in-out infinite;
}

.gate-container::after {
  content: '';
  position: absolute;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(101, 88, 245, 0.1), transparent);
  border-radius: 50%;
  bottom: -100px;
  left: -50px;
  pointer-events: none;
  animation: float 8s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-20px) rotate(180deg);
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .feature-badges {
    gap: 0.5rem;
  }
  
  .feature-badge {
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
  }
  
  .gate-tagline {
    font-size: 0.95rem;
  }
  
  .gate-logo-container::before,
  .gate-logo-container::after {
    display: none;
  }
}

/* 适应浏览器界面大小的自适应与整体缩减样式 */

.access-gate {
  overflow: hidden !important;
}

.access-gate-container {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100vh !important;
  overflow-y: auto !important; /* 极端情况下仍能滚动 */
  padding: 1rem 0 !important;
  box-sizing: border-box !important;
  gap: 1.25rem !important; /* 原为 2rem，缩小间距 */
}

.access-gate-container .gate-container {
  max-width: 410px !important; /* 原为 460px，整体宽度缩小一点更紧凑 */
  padding: 0 15px !important; /* 缩减外部内边距 */
  margin: 0 auto !important;
}

/* 缩减 Logo 与标题部分 */
.access-gate .logo {
  font-size: 2.6rem !important; /* 原为 3.5rem，标题缩小 */
  letter-spacing: 4px !important;
  margin-bottom: 0.3rem !important;
}

.access-gate .logo-badge {
  font-size: 0.95rem !important; /* 徽标等比缩小 */
  right: -32px !important;
  top: -2px !important;
  padding: 0.1rem 0.4rem !important;
}

.access-gate .gate-tagline {
  font-size: 0.95rem !important; /* 原为 1.1rem */
  margin-top: 0.3rem !important;
  padding-bottom: 0.6rem !important; /* 缩减下边距 */
}

/* 缩减特色标签 */
.access-gate .feature-badges {
  margin-top: 0.8rem !important; /* 原为 1.5rem */
  gap: 0.6rem !important; /* 标签间距缩小 */
}

.access-gate .feature-badge {
  padding: 0.35rem 0.75rem !important; /* 标签变小 */
  font-size: 0.8rem !important; /* 原为 0.85rem */
}

/* 缩减登录面板卡片与内部组件 */
.access-gate .gate-card-inner {
  padding: 1.5rem 1.75rem !important; /* 原为 2.5rem 2rem，减少内边距 */
}

.access-gate .gate-header {
  margin-bottom: 1.2rem !important; /* 原为 2rem */
}

.access-gate .gate-header h2 {
  font-size: 1.5rem !important; /* 原为 1.8rem */
  margin-bottom: 0.25rem !important;
}

.access-gate .gate-header p {
  font-size: 0.85rem !important; /* 原为 0.95rem */
}

.access-gate .login-method-toggle {
  margin-bottom: 1.2rem !important; /* 原为 1.5rem */
}

.access-gate .login-method-toggle button {
  padding: 8px 12px !important; /* 原为 10px 15px */
  font-size: 0.85rem !important; /* 原为 0.9rem */
}

.access-gate .form-group {
  margin-bottom: 1rem !important; /* 原为 1.2rem */
}

.access-gate .form-group label {
  margin-bottom: 4px !important;
  font-size: 0.8rem !important;
}

.access-gate .form-input {
  padding: 10px 14px !important; /* 原为 12px 16px */
  font-size: 0.9rem !important; /* 原为 1rem */
}

.access-gate .key-submit {
  padding: 11px !important; /* 原为 14px */
  font-size: 0.95rem !important;
  margin-top: 0.8rem !important;
}

.access-gate .gate-footer {
  margin-top: 1.2rem !important; /* 原为 1.5rem */
  font-size: 0.8rem !important;
}

.access-gate .gate-footer p {
  margin-bottom: 0.25rem !important;
}

/* 针对视口高度较窄的浏览器窗口进行极致适配 */
@media (max-height: 850px) {
  .access-gate-container {
    gap: 0.8rem !important;
  }
  .access-gate .logo {
    font-size: 2.2rem !important;
  }
  .access-gate .gate-tagline {
    font-size: 0.85rem !important;
    padding-bottom: 0.4rem !important;
  }
  .access-gate .feature-badges {
    margin-top: 0.6rem !important;
  }
  .access-gate .gate-card-inner {
    padding: 1.25rem 1.5rem !important;
  }
  .access-gate .gate-header {
    margin-bottom: 1rem !important;
  }
}

@media (max-height: 720px) {
  .access-gate-container {
    gap: 0.4rem !important;
  }
  .access-gate .logo {
    font-size: 1.8rem !important;
    margin-bottom: 0.1rem !important;
  }
  .access-gate .gate-tagline {
    display: none !important; /* 隐藏标语，腾出垂直空间 */
  }
  .access-gate .feature-badges {
    display: none !important; /* 隐藏特色标签，腾出垂直空间 */
  }
  .access-gate .gate-card-inner {
    padding: 1rem 1.25rem !important;
  }
  .access-gate .gate-header {
    margin-bottom: 0.8rem !important;
  }
  .access-gate .form-group {
    margin-bottom: 0.6rem !important;
  }
  .access-gate .form-input {
    padding: 8px 12px !important;
  }
  .access-gate .login-method-toggle {
    margin-bottom: 0.8rem !important;
  }
  .access-gate .key-submit {
    padding: 9px !important;
    margin-top: 0.5rem !important;
  }
  .access-gate .gate-footer {
    margin-top: 0.8rem !important;
  }
}

/* Light authentication surface — aligned with the landing cover */
.access-gate {
  min-height: 100vh;
  color: var(--hm-ink) !important;
  background:
    radial-gradient(circle at 86% 2%, rgba(66, 133, 244, 0.13), transparent 30rem),
    radial-gradient(circle at 5% 88%, rgba(52, 168, 83, 0.08), transparent 28rem),
    #fff !important;
}
.access-gate::after {
  background: radial-gradient(circle at 50% 42%, rgba(26, 115, 232, 0.08), transparent 48%) !important;
  animation: none !important;
}
.access-gate .gate-container::before {
  width: 360px !important; height: 360px !important; top: -185px !important; right: -210px !important;
  background: radial-gradient(circle, rgba(66, 133, 244, 0.11), transparent 70%) !important;
  animation: none !important;
}
.access-gate .gate-container::after {
  width: 300px !important; height: 300px !important; bottom: -170px !important; left: -190px !important;
  background: radial-gradient(circle, rgba(52, 168, 83, 0.07), transparent 70%) !important;
  animation: none !important;
}
.access-gate .gate-logo-container::before,
.access-gate .gate-logo-container::after { display: none !important; }
.access-gate .gate-logo-container { margin-bottom: 18px !important; }
.access-gate .gate-logo { margin-bottom: 4px !important; padding: 0 !important; }
.access-gate .gate-logo .logo {
  color: var(--hm-blue) !important;
  background: linear-gradient(135deg, var(--hm-blue), var(--hm-indigo)) !important;
  -webkit-background-clip: text !important; background-clip: text !important;
  -webkit-text-fill-color: transparent !important; text-shadow: none !important;
}
.access-gate .logo-glow,
.access-gate .logo-pulse,
.access-gate .logo-circuit { opacity: 0.18 !important; }
.access-gate .gate-tagline {
  margin-top: 2px !important; padding-bottom: 0 !important;
  color: #737b85 !important; background: none !important;
  -webkit-text-fill-color: currentColor !important; font-weight: 450 !important;
  letter-spacing: 0.03em !important; text-shadow: none !important; animation: none !important;
}
.access-gate .gate-card {
  overflow: hidden !important; color: var(--hm-ink) !important;
  background: rgba(255, 255, 255, 0.94) !important;
  border: 1px solid var(--hm-line) !important; border-radius: 26px !important;
  box-shadow: 0 22px 56px rgba(37, 55, 84, 0.12), 0 2px 8px rgba(37, 55, 84, 0.04) !important;
  transform: none !important; backdrop-filter: blur(20px) saturate(140%);
  animation: cardSlideIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) !important;
}
.access-gate .gate-card:hover {
  transform: none !important;
  box-shadow: 0 22px 56px rgba(37, 55, 84, 0.12), 0 2px 8px rgba(37, 55, 84, 0.04) !important;
}
.access-gate .gate-card::before {
  display: block !important; content: '' !important; position: absolute !important;
  inset: 0 0 auto !important; width: 100% !important; height: 3px !important; opacity: 1 !important;
  background: linear-gradient(90deg, var(--hm-blue), #58a6ff 52%, var(--hm-indigo)) !important;
}
.access-gate .gate-card::after { display: none !important; }
.access-gate .gate-card-inner {
  padding: 28px 30px 26px !important; color: var(--hm-ink) !important;
  background: transparent !important; border: 0 !important;
  border-radius: inherit !important; box-shadow: none !important;
}
.access-gate .gate-header { margin-bottom: 20px !important; }
.access-gate .gate-header h2 {
  margin-bottom: 6px !important; color: var(--hm-ink) !important;
  background: none !important; -webkit-text-fill-color: currentColor !important;
  font-size: 1.55rem !important; font-weight: 650 !important; letter-spacing: -0.025em !important;
}
.access-gate .gate-header p { color: #7a828c !important; font-size: 0.875rem !important; }
.access-gate .gate-form { margin-bottom: 18px !important; }
.access-gate .form-group label {
  margin-bottom: 7px !important; color: #4d5661 !important;
  font-size: 0.82rem !important; font-weight: 600 !important;
}
.access-gate .form-input {
  min-height: 46px !important; padding: 11px 14px !important;
  color: var(--hm-ink) !important; background: #f7f9fc !important;
  border: 1px solid #dce3ec !important; border-radius: 12px !important; box-shadow: none !important;
}
.access-gate .form-input::placeholder { color: #9aa1aa !important; }
.access-gate .form-input:focus {
  background: #fff !important; border-color: rgba(26, 115, 232, 0.62) !important;
  box-shadow: 0 0 0 4px rgba(26, 115, 232, 0.1) !important;
}
.access-gate .login-method-toggle {
  margin-bottom: 18px !important; padding: 4px; background: #f3f6fa !important;
  border: 1px solid #e1e6ee !important; border-radius: 12px !important;
}
.access-gate .login-method-toggle button {
  min-height: 38px !important; color: var(--hm-muted) !important;
  border-radius: 9px !important; font-weight: 550 !important;
}
.access-gate .login-method-toggle button.active {
  color: var(--hm-blue) !important; background: #fff !important; box-shadow: var(--hm-shadow-sm) !important;
}
.access-gate .login-method-toggle button:hover:not(.active) {
  color: #3f4955 !important; background: rgba(255, 255, 255, 0.66) !important;
}
.access-gate .key-submit,
.access-gate .send-code-btn {
  color: #fff !important; background: var(--hm-blue) !important;
  border: 1px solid var(--hm-blue) !important; border-radius: 12px !important;
  box-shadow: 0 8px 20px rgba(26, 115, 232, 0.18) !important;
}
.access-gate .key-submit {
  min-height: 48px !important; justify-content: center !important; gap: 10px !important;
  margin-top: 6px !important; font-weight: 650 !important;
}
.access-gate .send-code-btn { min-width: 94px; }
.access-gate .key-submit:hover,
.access-gate .send-code-btn:hover { background: var(--hm-blue-strong) !important; transform: translateY(-1px); }
.access-gate .key-submit .arrow-icon { color: rgba(255, 255, 255, 0.88) !important; }
.access-gate .gate-footer {
  margin-top: 14px !important; padding-top: 16px;
  color: #7a828c !important; border-top: 1px solid #edf0f4;
}
.access-gate .toggle-auth-btn,
.access-gate .code-hint { color: var(--hm-blue) !important; }
.access-gate .feature-badges { margin-top: 14px !important; }
.access-gate .feature-badge {
  color: #53606d !important; background: rgba(255, 255, 255, 0.72) !important;
  border: 1px solid #dfe6ef !important; box-shadow: 0 3px 12px rgba(37, 55, 84, 0.05) !important;
}
.access-gate .feature-badge i { color: var(--hm-blue) !important; animation: none !important; }
.access-gate .auth-success { color: #137333 !important; background: #eaf6ed !important; border-color: #b8dfc2 !important; }
.access-gate .auth-error { color: #b3261e !important; background: #fdf0ef !important; border-color: #f1c4c0 !important; }

@media (max-width: 600px) {
  .access-gate .gate-card-inner { padding: 24px 20px 22px !important; }
  .access-gate .gate-card { border-radius: 21px !important; }
}
